import { render, staticRenderFns } from "./SelectColor.vue?vue&type=template&id=5b340e02&scoped=true"
import script from "./SelectColor.vue?vue&type=script&lang=js"
export * from "./SelectColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b340e02",
  null
  
)

export default component.exports